/**
 * Javascript file for the page with a list of business model aspects.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import { getBmas } from "../../../../api";
export default {
  name: "BusinessModelSearch",

  /**
   * TODO: finish filling these fields.
   * The vue instance's data object.
   * @property {boolea} loading - Information is currently being processed.
   * @property {string} msg - The platform's name.
   * @property {string} searchterm - The search term for the business model search.
   * @property {any[]} bmas - The business model aspects.
   * @property {any[]} bmastrings - 
   * @property {any[]} searchresults - The result set of the search.
   * 
   * //TODO: Is this searchterm a duplicate?
   * @property {string} searchterm - 
   * 
   * @property {boolean} searchoptions.shouldSort - 
   * @property {number} searchoptions.threshold -
   * @property {number} searchoptions.location -
   * @property {number} searchoptions.distance - 
   * @property {number} searchoptions.maxPatternLength - The maximum length a pattern may have. 
   * @property {number} searchoptions.minMatchCharLength - The minimum amount of characters that have to match between 
   * the search result and the search term for a result to be shown to the user.  
   * @property {string[]} searchoptions.keys - The key values for the search.
   */
  data() {
    return {
      loading: false,
      msg: "WERNER",
      searchterm: "",
      bmas: [],
      bmastrings: [],
      searchresults: [],
      //TODO: is this msg a duplicate?
      msg: "WERNER",
      searchterm: "",
      searchoptions: {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name", "description"]
      }
    };
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Recursively includes all of the business model's children. 
     * @param {*} tes - The tree elements. 
     */
    recurse(tes) {
      for (let i = 0; i < tes.length; i++) {
        if (!this.bmastrings.includes(tes[i].name)) {
          this.bmastrings.push(tes[i].name);
          this.bmas.push(tes[i]);
        }
        this.recurse(tes[i].children);
      }
    },

    /**
     * Conducts a search. 
     */
    search() {
      this.$search(this.searchterm, this.bmas, this.searchoptions).then(
        results => {
          this.searchresults = results;
        }
      );
    },

    /**
     * Shortens the description.
     * @param {*} desc - The description.
     */
    shorten(desc) {
      var res = desc.substring(0, 500) + "...";
      return res;
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    }
  },

  /**
   * Expressions to watch.
   */
  watch: {
    searchterm: function () {
      //console.log("mhh");
      this.search();
    }
  },

  /**
   * Called after the instance has been mounted.
   */
  mounted() {
    this.loading = true;
    getBmas()
      .then(res => {
        //console.log(res);
        this.recurse(res);
        for (let i = 0; i < this.bmas.length; i++) {
          if (
            this.bmas[i].name == "Schlüsselpartnerschaften" ||
            this.bmas[i].name == "Kundensegment" ||
            this.bmas[i].name == "Wertangebot" ||
            this.bmas[i].name == "Schlüsselaktivitäten" ||
            this.bmas[i].name == "Kostenstruktur" ||
            this.bmas[i].name == "Schlüsselressourcen" ||
            this.bmas[i].name == "Einnahmequellen" ||
            this.bmas[i].name == "Kundenbeziehung" ||
            this.bmas[i].name == "Kanäle"
          ) {
            this.searchresults.push(this.bmas[i]);
          }
        }
        this.loading = false;
      })
      .catch(err => {
        //console.log(err);
        this.loading = false;
      });
  }
};



// WEBPACK FOOTER //
// ./src/components/search/businessmodelsearch/query/businessmodelsearch.js